// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U1TN","badges":"styles_badges__1zvK-"};